export default "__VITE_ASSET__ab430e9f__"